class preload {
	constructor() {
	}
	init() {
		return new Promise( (resolve, reject) => {
			var doc = document;
			var img = document.getElementsByTagName('img');
			var dataImgPc = document.querySelectorAll('[data-img-pc]');
			var dataBgImgPc = document.querySelectorAll('[data-bgimg-pc]');
			var srcObj = [];
			var imgList = [];
			var count = 0;
			var prop = null;
			var reg = /url\([^"].*\)/;
			var i = 0;

			function convertAbsUrl(relativePath){
				var anchor = document.createElement('img');
				anchor.src = relativePath;
				return anchor.src;
			}
			function loadcomplete() {	
				if (++count === len) {
					// console.log('PRELOAD INIT');
					resolve();
				}
			}

			i = 0;
			while(i < dataImgPc.length) {
				srcObj.push(convertAbsUrl(dataImgPc[i].dataset.imgPc));
				srcObj.push(convertAbsUrl(dataImgPc[i].dataset.imgSp));
				i = (i + 1) | 0;
			}

			i = 0;
			while(i < dataBgImgPc.length) {
				srcObj.push(convertAbsUrl(dataBgImgPc[i].dataset.bgimgPc));
				srcObj.push(convertAbsUrl(dataBgImgPc[i].dataset.bgimgSp));
				i = (i + 1) | 0;
			}

			i = 0;
			while(i < img.length) {
				if(img[i].src.indexOf('.jpg') != -1 || img[i].src.indexOf('.png') != -1 || img[i].src.indexOf('.gif') != -1 || img[i].src.indexOf('.svg') != -1) {
					srcObj.push(convertAbsUrl(img[i].src));
				}
				i = (i + 1) | 0;
			}

			i = 0;
			while(i < doc.all.length) {
				prop = doc.defaultView.getComputedStyle( doc.all[i], null ).getPropertyValue('background').replace(/"/g, '').match(reg);
			    if(prop != null) {
			        srcObj.push(prop[0].replace('url(', '').replace(')', ''));
			    }
				i = (i + 1) | 0;
			}

			// console.log(srcObj);

			var len = srcObj.length;

			if(len > 0) {
				i = 0;
				while(i < len) {
					imgList[i] = new Image(); 
					imgList[i].onload = loadcomplete;
					imgList[i].onerror = loadcomplete;
					imgList[i].src = srcObj[i];
					i = (i + 1) | 0;
				}
			}else{
				resolve();
			}
		});
	}
}

export default preload;


// WEBPACK FOOTER //
// ./src/assets/js/preload.js